import React from 'react'
import Helmet from 'react-helmet'
import Textarea from 'react-autosize-textarea'
import cx from 'classnames'
import map from 'lodash/map'
import AwesomeLoader from 'components/AwesomeLoader'
import { observer } from 'mobx-react'
import ShadowBox from 'components/ShadowBox'
import Rating from 'components/Rating'
import CheckButton from 'components/CheckButton'
import intercomUpdate from 'decorators/intercomUpdate'
import RatingCategories from 'misc/RatingCategories'
import './styles.sass'

@intercomUpdate({ screen: 'Rate Project' })
@observer
export default class RateProjectScreen extends React.Component {
  componentWillMount () {
    return this.props.rootStore.rateProjectStore.activate(this.props.params.id)
  }

  renderLoader () {
    return (
      <div>
        <Helmet title="Taxfyle" />
        <AwesomeLoader />
      </div>
    )
  }

  render () {
    const store = this.props.rootStore.rateProjectStore
    const currentUser = this.props.rootStore.authStore.user
    const project = store.project
    if (store.loading || !project) return this.renderLoader()
    return (
      <div className="rate-project-screen">
        <Helmet title={project.name} />
        <div className="inner">
          <div className="info has-text-centered">
            <h1 className="title is-2 is-semibold">
              {currentUser.firstName}, thank you for using Taxfyle!
            </h1>
            <p className="info-text">
              In order for us to provide the highest quality work, we ask that
              you rate your experience with <strong>{project.provider.name}</strong>.
            </p>
          </div>

          <ShadowBox level={5} className="rating-box">
            <div className="box-header">
              <div className="header-text">
                How do you rate your experience?
              </div>
            </div>

            <div className="box-content">
              <div className="rating-container">
                <Rating
                  readonly={store.disabled}
                  rating={store.rating}
                  starSize={48}
                  onRatingClick={(e, rating) => store.rate(rating)}
                />
              </div>
              {store.hasRated &&
                <div className="categories-section">
                  <h4 className="categories-prompt">
                    {store.categoriesPromptText}
                  </h4>
                  <div className="categories">
                    {map(RatingCategories, (friendly, key) =>
                      <div className="category" key={key}>
                        <CheckButton
                          disabled={store.disabled}
                          checked={store.categorySelected(key)}
                          onChange={() => store.toggleRatingCategory(key)}
                        >
                          {friendly}
                        </CheckButton>
                      </div>
                    )}
                  </div>
                </div>
              }
              {store.canSubmit &&
                <div className="comment-box">
                  <Textarea
                    disabled={store.disabled}
                    type="text"
                    className="input comment-field"
                    placeholder={`Have any feedback for ${project.provider.name}?`}
                    onChange={e => store.changeComment(e.target.value)}
                    value={store.comment}
                  />
                </div>
              }
              {store.canSubmit &&
                <div className="has-spacing-top--less">
                  <button
                    className={cx('button has-impact is-black is-medium', store.disabled && 'is-loading')} onClick={() => store.submit()}
                    disabled={store.disabled}
                  >
                    Submit
                  </button>
                </div>
              }
            </div>
          </ShadowBox>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/RateProject/index.jsx